import gql from 'graphql-tag';

export const all = gql`query getClientContacts($clientId: ID!) {
    clientContacts (clientId: $clientId){
        id
        name
        phone
        mobile
        fax
        email
        isArchived
        mainContact
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/clientContact.js